"use strict";
/**
 * Unless explicitly stated otherwise all files in this repository are licensed under the Apache-2.0 License.
 * This product includes software developed at Datadog (https://www.datadoghq.com/).
 * Copyright 2020-Present Datadog, Inc.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GCPAccount = void 0;
/**
 * Your Google Cloud Platform Account.
 */
class GCPAccount {
    constructor() { }
    /**
     * @ignore
     */
    static getAttributeTypeMap() {
        return GCPAccount.attributeTypeMap;
    }
}
exports.GCPAccount = GCPAccount;
/**
 * @ignore
 */
GCPAccount.attributeTypeMap = {
    authProviderX509CertUrl: {
        baseName: "auth_provider_x509_cert_url",
        type: "string",
    },
    authUri: {
        baseName: "auth_uri",
        type: "string",
    },
    automute: {
        baseName: "automute",
        type: "boolean",
    },
    clientEmail: {
        baseName: "client_email",
        type: "string",
    },
    clientId: {
        baseName: "client_id",
        type: "string",
    },
    clientX509CertUrl: {
        baseName: "client_x509_cert_url",
        type: "string",
    },
    errors: {
        baseName: "errors",
        type: "Array<string>",
    },
    hostFilters: {
        baseName: "host_filters",
        type: "string",
    },
    isCspmEnabled: {
        baseName: "is_cspm_enabled",
        type: "boolean",
    },
    privateKey: {
        baseName: "private_key",
        type: "string",
    },
    privateKeyId: {
        baseName: "private_key_id",
        type: "string",
    },
    projectId: {
        baseName: "project_id",
        type: "string",
    },
    tokenUri: {
        baseName: "token_uri",
        type: "string",
    },
    type: {
        baseName: "type",
        type: "string",
    },
};
//# sourceMappingURL=GCPAccount.js.map